/**
 * Cycle task payloads keep two GL lists:
 * `__tblinks` is the trial-balance document ids used to update bookclosure_tb.reference.
 * `glcode` is the account-code strings stored on bookclosure_checklist.
 */

/**
 * Trial-balance rows that carry both `_id` and the account code.
 * `__tbtotals.items` wins over the computed copy.
 * @param {object} task
 * @returns {object[]}
 */
export function tbTotalsItems(task) {
  const direct = task?.__tbtotals?.items;
  if (Array.isArray(direct) && direct.length) return direct;
  const computed = task?.__computed?.tbtotals?.items;
  if (Array.isArray(computed) && computed.length) return computed;
  return [];
}

/**
 * Account-code strings for the selected trial-balance ids.
 * @param {Array<*>} tbLinks
 * @param {object[]} items
 * @returns {string[]}
 */
export function accountCodesForTbLinks(tbLinks, items) {
  const byId = new Map();
  for (const item of items || []) {
    const code = item?.glcode;
    if (code == null || code === '' || typeof code === 'object') continue;
    const text = String(code).trim();
    if (!text || item?._id == null) continue;
    byId.set(String(item._id), text);
  }
  const codes = [];
  for (const link of tbLinks || []) {
    const key = String(link).trim();
    if (!key) continue;
    const fromItem = byId.get(key);
    if (fromItem) {
      codes.push(fromItem);
      continue;
    }
    // Already an account code (bulk-style), not a trial-balance id.
    if (!/^[a-f0-9]{24}$/i.test(key)) codes.push(key);
  }
  return codes;
}

/**
 * `glcode` strings plus `__tblinks` ids for edit and validate payloads.
 * @param {Array<*>} tbLinks
 * @param {object} task
 * @returns {{ glcode: string[], __tblinks: string[] }}
 */
export function glPayloadFromSelection(tbLinks, task) {
  const links = Array.isArray(tbLinks) ? tbLinks.map((id) => String(id)) : [];
  return {
    __tblinks: links,
    glcode: accountCodesForTbLinks(links, tbTotalsItems(task)),
  };
}
